import axios from './index';

// 查询 banner 列表
export const fetchHomeBannerList = () => {
  return axios.get('/api/homepage/banner');
};

// 查询 project 列表
export const fetchHomeProjectList = () => {
  return axios.get('/api/homepage/project');
};

// 查询 project 详情
export const fetchProjectDetail = (id) => {
  return axios.get('/api/charity/project' + `/${id}`);
};

// 查询 news 列表
export const fetchHomeNewsList = () => {
  return axios.get('/api/homepage/news');
};

// 查询 news 专栏
export const fetchHomeNewsBanner = () => {
  return axios.get('/api/homepage/news/fullscreen');
};

// 查询 news 详情
export const fetchNewsDetail = (id) => {
  return axios.get('/api/homepage/news' + `/${id}`);
};

// 查询 关于我们 列表
export const fetchHomeAboutUsList = () => {
  return axios.get('/api/homepage/about');
};

// 查询 性别 列表
export const fetchGenderList = () => {
  return axios.get('/api//homepage/dict/type/gender');
};

// 生成支付链接
export const createPaypalOrder = (data) => {
  return axios.post('/api/homepage/paypal/createOrder', data);
};

// 提交支付信息订阅
export const submitReceipt = (data) => {
  return axios.post('/api/homepage/receipt/submit', data);
};

// 提交订阅
export const submitSubscriber = (data) => {
  return axios.post('/api/homepage/subscriber', data);
};
